function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function (obj) { return typeof obj; }; } else { _typeof = function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Trigger from '@cloud-sn/v-trigger';
import { VTimePickerPanel } from '@cloud-sn/v-timepicker';
import { formatDate, normalizeDate } from '../utils';
import Calendar from '../calendar.js';
import localeEN from '../locale/en_US';
import placements from './placements';
var __vue_script__ = {
  name: 'DatePicker',
  components: {
    Calendar: Calendar,
    Trigger: Trigger,
    TimePickerPanel: VTimePickerPanel
  },
  props: {
    prefixCls: {
      type: String,
      default: 'v-calendar'
    },
    pickerPrefixCls: {
      type: String,
      default: 'v-calendar-picker'
    },
    locale: {
      type: Object,
      default: function _default() {
        return localeEN;
      }
    },
    mode: {
      type: String,
      default: undefined
    },
    theme: {
      type: String,
      default: 'light'
    },
    isOpen: {
      type: Boolean,
      default: false
    },
    value: Date,
    disabled: Boolean,
    format: String,
    showTime: [Boolean, Object],
    showToday: Boolean,
    showOk: {
      type: Boolean,
      default: function _default() {
        return !!this.showTime;
      }
    },
    showDateInput: Boolean,
    dateInputPlaceholder: String,
    disabledDate: Function,
    disabledTime: Function,
    placement: {
      type: String,
      default: 'bottomLeft'
    },
    transitionName: {
      type: String,
      default: ''
    },
    animation: {
      type: String,
      default: ''
    },
    getPopupContainer: {
      type: Function,
      default: null
    },
    okConfirm: {
      type: Boolean,
      default: false
    },
    controlMode: {
      type: Boolean,
      default: false
    },
    showWeekNumber: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      buildinPlacements: placements,
      innerValue: null,
      inputValue: null,
      open: false,
      align: {// points: ['tl', 'tl'],
      },
      disabledHours: null,
      disabledMinutes: null,
      disabledSeconds: null
    };
  },
  computed: {
    inputClasses: function inputClasses() {
      var prefixCls = this.prefixCls;
      return _defineProperty({}, "".concat(prefixCls, "-picker-input"), true);
    },
    actions: function actions() {
      var disabled = this.disabled;
      return disabled ? [] : ['click'];
    },
    formatValue: function formatValue() {
      var inputValue = this.inputValue,
          dateFormat = this.dateFormat;

      if (!inputValue) {
        return '';
      }

      return formatDate(inputValue, dateFormat);
    },
    isShowTime: function isShowTime() {
      return !!this.showTime;
    },
    timeProps: function timeProps() {
      var showTime = this.showTime;

      if (_typeof(showTime) === 'object') {
        return showTime;
      }

      return {};
    },
    dateFormat: function dateFormat() {
      var format = this.format,
          isShowTime = this.isShowTime;
      return format || (isShowTime ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD');
    },
    isHasOkButton: function isHasOkButton() {
      var isShowTime = this.isShowTime,
          showOk = this.showOk;
      return showOk === true || showOk !== false && !!isShowTime;
    },
    isOkConfirm: function isOkConfirm() {
      var isHasOkButton = this.isHasOkButton,
          okConfirm = this.okConfirm;
      return isHasOkButton && okConfirm;
    },
    timePickerPanelProps: function timePickerPanelProps() {
      var prefixCls = this.prefixCls,
          innerValue = this.innerValue,
          disabledHours = this.disabledHours,
          disabledMinutes = this.disabledMinutes,
          disabledSeconds = this.disabledSeconds,
          timeProps = this.timeProps;
      return _objectSpread({
        showHour: true,
        showMinute: true,
        showSecond: true
      }, timeProps, {
        prefixCls: "".concat(prefixCls, "-time-picker"),
        value: innerValue,
        disabledHours: disabledHours,
        disabledMinutes: disabledMinutes,
        disabledSeconds: disabledSeconds
      });
    },
    bindListeners: function bindListeners() {
      var $listeners = this.$listeners,
          onPanelChange = this.onPanelChange,
          onSelect = this.onSelect,
          onOk = this.onOk;
      return _objectSpread({}, $listeners, {
        'on-panel-change': onPanelChange,
        'on-select': onSelect,
        'on-ok': onOk
      });
    }
  },
  watch: {
    value: function value(nVal, oVal) {
      if (nVal !== oVal) {
        var validDate = normalizeDate(nVal);
        this.innerValue = validDate;
        this.inputValue = validDate;
      }
    },
    isOpen: function isOpen(nVal) {
      this.setOpen(nVal);
    }
  },
  created: function created() {
    var value = this.value,
        isOpen = this.isOpen,
        disabledTime = this.disabledTime,
        disabled = this.disabled;
    var validDate = normalizeDate(value);
    this.innerValue = validDate;
    this.inputValue = validDate;
    this.setOpen(disabled ? false : isOpen);

    if (disabledTime) {
      var opts = disabledTime(validDate);
      this.disabledHours = opts.disabledHours;
      this.disabledMinutes = opts.disabledMinutes;
      this.disabledSeconds = opts.disabledSeconds;
    }
  },
  methods: {
    setOpen: function setOpen(flag) {
      this.open = flag;
    },
    onPanelChange: function onPanelChange() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      this.$emit.apply(this, ['panel-change'].concat(args));
    },
    onChange: function onChange(val) {
      var hide = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var setOpen = this.setOpen,
          dateFormat = this.dateFormat;
      this.inputValue = val;
      this.$emit('change', val, formatDate(val, dateFormat));

      if (hide) {
        setOpen(false);
      }
    },
    onSelect: function onSelect(val) {
      var isOkConfirm = this.isOkConfirm,
          isHasOkButton = this.isHasOkButton,
          onChange = this.onChange;
      this.innerValue = val;

      if (!isOkConfirm) {
        onChange(val, !isHasOkButton);
      }
    },
    onFocus: function onFocus(e) {
      this.$emit('focus', e);
    },
    onPopupVisible: function onPopupVisible(visible) {
      if (visible) {
        this.innerValue = this.inputValue;
      }

      this.setOpen(visible);
      this.$emit('open-change', visible);
    },
    onOk: function onOk(value) {
      var isHasOkButton = this.isHasOkButton,
          isOkConfirm = this.isOkConfirm,
          onChange = this.onChange;
      this.setOpen(false);

      if (isHasOkButton) {
        this.$emit('ok', value);

        if (isOkConfirm) {
          onChange(value);
        }
      }
    }
  }
};
/* template */

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('trigger', {
    attrs: {
      "prefix-cls": _vm.pickerPrefixCls,
      "visible": _vm.open,
      "actions": _vm.actions,
      "popup-align": _vm.align,
      "popup-placement": _vm.placement,
      "builtin-placements": _vm.buildinPlacements,
      "popup-transition-name": _vm.transitionName,
      "popup-animation": _vm.animation,
      "get-popup-container": _vm.getPopupContainer,
      "destroy-popup-on-hide": ""
    },
    on: {
      "on-popup-visible-change": _vm.onPopupVisible
    }
  }, [_c('template', {
    slot: "trigger"
  }, [_vm._t("trigger")], 2), _vm._v(" "), _c('calendar', _vm._g({
    class: _vm.prefixCls + "-" + _vm.theme,
    attrs: {
      "slot": "popup",
      "prefix-cls": _vm.prefixCls,
      "value": _vm.innerValue,
      "mode": _vm.mode,
      "locale": _vm.locale,
      "format": _vm.dateFormat,
      "show-ok": _vm.showOk,
      "has-time-picker": _vm.isShowTime,
      "show-today": _vm.showToday,
      "show-time": _vm.showTime,
      "disabled-date": _vm.disabledDate,
      "disabled-time": _vm.disabledTime,
      "date-input-placeholder": _vm.dateInputPlaceholder,
      "control-mode": _vm.controlMode,
      "show-date-input": _vm.showDateInput,
      "show-week-number": _vm.showWeekNumber
    },
    slot: "popup",
    scopedSlots: _vm._u([{
      key: "timePicker",
      fn: function fn(props) {
        return [_vm.isShowTime ? _c('time-picker-panel', _vm._b({
          on: {
            "on-change": props.onChange
          }
        }, 'time-picker-panel', _vm.timePickerPanelProps, false)) : _vm._e()];
      }
    }])
  }, _vm.bindListeners))], 2);
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* component normalizer */

function __vue_normalize__(template, style, script, scope, functional) {
  var component = (typeof script === 'function' ? script.options : script) || {}; // For security concerns, we use only base name in production mode.

  component.__file = "datePicker.js";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;
  return component;
}
/* style inject */

/* style inject SSR */


export default __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, undefined, undefined);